import { t } from "i18next";
import { VerySadFace, SadFace, NeutralFace, HappyFace, VeryHappyFace } from "./Faces";
import { VerySadTickIcon, SadTickIcon, NeutralTickIcon, HappyTickIcon, VeryHappyTickIcon, NullTickIcon } from "./Ticks";

export const Mood = {
  VerySad: 1,
  Sad: 2,
  Neutral: 3,
  Happy: 4,
  VeryHappy: 5,
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Mood = (typeof Mood)[keyof typeof Mood];

export interface MoodData {
  title: string;
  description: string;
}

export const moodData = (mood: Mood): MoodData => {
  switch (mood) {
    case 1:
      return t("home.moodTracker.moods.verySad", { returnObjects: true });
    case 2:
      return t("home.moodTracker.moods.sad", { returnObjects: true });
    case 3:
      return t("home.moodTracker.moods.neutral", { returnObjects: true });
    case 4:
      return t("home.moodTracker.moods.happy", { returnObjects: true });
    case 5:
      return t("home.moodTracker.moods.veryHappy", { returnObjects: true });
  }
};

export const moodFace = (mood: Mood, size?: string): JSX.Element => {
  switch (mood) {
    case 1:
      return <VerySadFace size={size} />;
    case 2:
      return <SadFace size={size} />;
    case 3:
      return <NeutralFace size={size} />;
    case 4:
      return <HappyFace size={size} />;
    case 5:
      return <VeryHappyFace size={size} />;
  }
};

export const moodBgColour = (mood: Mood): string => {
  switch (mood) {
    case 1:
      return "bg-l-red";
    case 2:
      return "bg-l-red";
    case 3:
      return "bg-l-yellow";
    case 4:
      return "bg-l-green";
    case 5:
      return "bg-l-green";
  }
};

export const moodTickIcon = (mood?: Mood): JSX.Element => {
  switch (mood) {
    case 1:
      return <VerySadTickIcon />;
    case 2:
      return <SadTickIcon />;
    case 3:
      return <NeutralTickIcon />;
    case 4:
      return <HappyTickIcon />;
    case 5:
      return <VeryHappyTickIcon />;
    default:
      return <NullTickIcon />;
  }
};
